var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Menu'),_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }